// Import Images
import product1 from "../../assets/images/products/img-1.png";
import product2 from "../../assets/images/products/img-2.png";
import product3 from "../../assets/images/products/img-3.png";
import product4 from "../../assets/images/products/img-4.png";
import product5 from "../../assets/images/products/img-5.png";

import company1 from "../../assets/images/companies/img-1.png";
import company2 from "../../assets/images/companies/img-2.png";
import company3 from "../../assets/images/companies/img-3.png";
import company5 from "../../assets/images/companies/img-5.png";
import company8 from "../../assets/images/companies/img-8.png";

import avatar1 from "../../assets/images/users/avatar-1.jpg";
import avatar2 from "../../assets/images/users/avatar-2.jpg";
import avatar3 from "../../assets/images/users/avatar-3.jpg";
import avatar4 from "../../assets/images/users/avatar-4.jpg";
import avatar6 from "../../assets/images/users/avatar-6.jpg";

import
{
  format,
  subMonths,
  subYears,
  subWeeks,
  parseISO,
  startOfWeek,
  startOfMonth,
  startOfYear,
} from "date-fns";

import axios from "axios";
import axiosInstance from "../../axiosConfig";
import { useEffect } from "react";
const authUser = JSON.parse( localStorage.getItem( "authUser" ) );
const token = authUser ? authUser.accessToken : null;

// !---------------------------- Functions Admin
// Récupération du nombre de client
/**
 * Lit un compteur dans une réponse du serveur.
 *
 * Les points d'entrée ont changé de forme : ils renvoyaient des lignes SQL
 * (`data: [{ total_client: 3 }]`), ils renvoient désormais un objet
 * (`data: { total_client: 3 }`). L'administration lisait encore `data[0]`, et
 * `objet.length` valant `undefined`, tous les compteurs retombaient à zéro.
 *
 * On accepte les deux formes, et plusieurs noms de champ : ils diffèrent d'un
 * point d'entrée à l'autre.
 *
 * @param {object} res réponse axios
 * @param {...string} noms noms de champ possibles, par ordre de préférence
 * @returns {number} la valeur trouvée, 0 sinon
 */
function lireCompteur ( res, ...noms )
{
  const charge = res?.data?.data;
  if ( !charge ) return 0;

  const source = Array.isArray( charge ) ? charge[ 0 ] : charge;
  if ( !source ) return 0;

  for ( const nom of noms )
  {
    const valeur = source[ nom ];
    if ( valeur !== undefined && valeur !== null ) return Number( valeur ) || 0;
  }

  return 0;
}

/**
 * Traduit une période en paramètres de requête.
 *
 * Le sélecteur du tableau de bord n'était relié à rien : il portait une date
 * en dur héritée du gabarit et n'accompagnait aucun appel.
 *
 * @param {{ debut?: Date, fin?: Date }} [periode]
 * @returns {object} params axios, vide si la période est ouverte
 */
function paramsPeriode ( periode )
{
  if ( !periode?.debut && !periode?.fin ) return {};

  const enJour = ( d ) => new Date( d ).toISOString().slice( 0, 10 );

  return {
    ...( periode.debut ? { date_debut: enJour( periode.debut ) } : {} ),
    ...( periode.fin ? { date_fin: enJour( periode.fin ) } : {} ),
  };
}

async function getNumberClients ()
{
  try
  {
    const res = await axiosInstance.get( "/totalclient/" );
    return lireCompteur( res, "total_client", "total" );
  } catch ( error )
  {
    console.error( "Erreur de récupération du nombre de client: ", error );
    return 0;
  }
}

// Récupération du nombre des chauffeurs
async function getNumberChauffeurs ()
{
  try
  {
    // La route est déclarée « /totalConducteur/ » : la casse compte.
    const res = await axiosInstance.get( "/totalConducteur/" );
    return lireCompteur( res, "total_conducteur", "total" );
  } catch ( error )
  {
    console.log( "Erreur de récupération du nombre de conducteur: ", error );
    return 0;
  }
}

// Récupération du nombre de Livreurs
async function getNumberLivreurs ()
{
  try
  {
    const res = await axiosInstance.get( "/totalLivreur/" );
    // Le champ s'appelle « total_livreur » ici, pas « total_conducteur ».
    return lireCompteur( res, "total_livreur", "total_conducteur", "total" );
  } catch ( error )
  {
    console.log( "Erreur de récupération du nombre de livreur: ", error );
    return 0;
  }
}

// Récupération le solde total
async function getSoldeTransaction ( periode )
{
  try
  {
    const res = await axiosInstance.get( "/totalTransaction/", {
      params: paramsPeriode( periode ),
    } );

    // console.log( "Response from getSoldeTransaction():", res );
    // console.log( "Data from getSoldeTransaction():", res.data.data );
    return res.data && res.data.data ? res.data.data : null;
  } catch ( error )
  {
    console.log( error );
    return null;
  }
}

// Récupération des courses
async function getCourses ( periode )
{
  const defaultResponse = {
    Attente: 0,
    Annuler: 0,
    Terminer: 0,
    Encours: 0,
  };

  try
  {
    const resStartCourse = await axiosInstance.get( "/statistiqueCourse/", {
      params: paramsPeriode( periode ),
    } );

    const dataStartCourse = resStartCourse.data.data
    return dataStartCourse
      ? {
        Attente: Number( dataStartCourse.total_courses_attente ?? dataStartCourse.en_attente ) || 0,
        Annuler: Number( dataStartCourse.total_courses_annule ?? dataStartCourse.annulees ) || 0,
        Terminer: Number( dataStartCourse.total_courses_terminer ?? dataStartCourse.terminees ) || 0,
        Encours: Number( dataStartCourse.total_courses_en_cours ?? dataStartCourse.commencees ) || 0,
      }
      : defaultResponse;
  } catch ( error )
  {
    console.error( "Echec de récupération des courses: ", error );
    return defaultResponse;
  }
}

// Récupération des livraisons
async function getLivraisons ( periode )
{
  const defaultResponse = {
    Attente: 0,
    Annuler: 0,
    Terminer: 0,
    Encours: 0,
  };

  try
  {

    const resStartLivraison = await axiosInstance.get( "/statistiqueLivraison/", {
      params: paramsPeriode( periode ),
    } );

    const dataStartLivraison = resStartLivraison.data.data
    return dataStartLivraison
      ? {
        Attente: Number( dataStartLivraison.total_livraisons_attente ?? dataStartLivraison.en_attente ) || 0,
        Annuler: Number( dataStartLivraison.total_livraisons_annule ?? dataStartLivraison.annulees ) || 0,
        Terminer: Number( dataStartLivraison.total_livraisons_terminer ?? dataStartLivraison.terminees ) || 0,
        Encours: Number( dataStartLivraison.total_livraisons_en_cours ?? dataStartLivraison.commencees ) || 0,
      }
      : defaultResponse;
  } catch ( error )
  {
    console.error( "Echec de récupération des livraisons: ", error );
    return defaultResponse;
  }
}

// Récupération des evenements
async function getEvent ()
{
  const defaultResponse = {
    total_passe_non_publier: 0,
    total_passe_publier: 0,
    total_avenir_non_publier: 0,
    total_avenir_publier: 0,
    total_en_cour_non_publier: 0,
    total_en_cour_publier: 0,
  };

  try
  {
    const res = await axiosInstance.get( "/totalEvent/" );

    // console.log( "Response from getEvent():", res );
    // console.log( "Data from getEvent():", res.data.data );
    return res.data && res.data.data ? res.data.data : defaultResponse;
  } catch ( error )
  {
    console.log( error );
    return defaultResponse;
  }
}

// Récupération des revenues par mois
async function getRevenueMonth ()
{
  try
  {
    const res = await axiosInstance.get( "/RevenuesMois/" );

    // console.log( "Response from getRevenueMonth():", res );
    // console.log( "Data from getRevenueMonth() mois:", res.data.mois );
    return res.data && res.data.mois ? res.data.mois : null;
  } catch ( error )
  {
    console.log( error );
    return null;
  }
}

// Récupération des revenues des tickets par mois
async function getRevenueTicketMonth ()
{
  try
  {
    const res = await axiosInstance.get( "/getrevenuesventetickets/" );

    // console.log( "Response from getRevenueMonth():", res );
    // console.log( "Data from getRevenueMonth() mois:", res.data.mois );
    return res.data && res.data.mois ? res.data.mois : null;
  } catch ( error )
  {
    console.log( error );
    return null;
  }
}

// Récupération de la liste des courses des chauffeurs
async function getCoursesChauffeurList ()
{
  try
  {
    const res = await axiosInstance.get( "/coursedetail/" );
    // return res.data ? res.data.data : null;
    let data = res.data ? res.data.data : null;
    return data;
  } catch ( error )
  {
    console.log( "Erreur lors de la récupération des courses: ", error );
    return null;
  }
}

// Récupération de la liste des courses des livreurs
async function getCoursesLivreurList ()
{
  try
  {
    const res = await axiosInstance.get( "/livraisondetail/" );
    // return res.data ? res.data.data : null;
    let data = res.data ? res.data.data : null;
    return data;
  } catch ( error )
  {
    console.error( "Erreur lors de la récupération des livraisons: ", error );
    return null;
  }
}


// !--------------------- Functions


// !=== Dashboard
// Récupérer
async function widgetDataApp ( periode )
{
  const clientCounter = await getNumberClients();
  // console.log( "ClientCounter: ", clientCounter );

  const chauffeursCounter = await getNumberChauffeurs();
  // console.log( "ChauffeursCounter: ", chauffeursCounter );

  const livreurCounter = await getNumberLivreurs();
  // console.log( "LivreurCounter: ", livreurCounter );

  // Seules les transactions suivent la période : les trois autres tuiles
  // comptent une population, pas une activité, et un total cumulé y reste la
  // lecture attendue.
  const transactions = await getSoldeTransaction( periode );

  return [
    {
      id: 1,
      cardColor: "primary",
      label: "Customers",
      counter: clientCounter,
      link: "Customers List",
      location: "/client",
      bgcolor: "success",
      icon: "bx bx-user",
      decimals: 0,
      prefix: "",
      separator: ".",
      suffix: "",
    },
    {
      id: 2,
      cardColor: "secondary",
      label: "Drivers",
      counter: chauffeursCounter,
      link: "Drivers List",
      location: "/chauffeur",
      bgcolor: "info",
      icon: "bx bx-car",
      decimals: 0,
      prefix: "",
      separator: ".",
      suffix: "",
    },
    {
      id: 3,
      cardColor: "success",
      label: "Deliverers",
      counter: livreurCounter,
      link: "List of deliverers",
      location: "/livreur",
      bgcolor: "warning",
      icon: "bx bx-shopping-bag",
      decimals: 0,
      prefix: "",
      separator: ".",
      suffix: "",
    },
    {
      id: 4,
      cardColor: "info",
      label: "Transactions",
      badgeClass: "muted",
      // Le serveur renvoie « total » ; « total_transactions » n'existe plus.
      counter:
        ( transactions &&
          ( transactions.total ?? transactions.total_transactions ) ) ||
        0,
      link: "Transaction history",
      location: "/organisateurs-paid",
      bgcolor: "primary",
      icon: "bx bx-wallet",
      decimals: 0,
      prefix: "XOF ",
      separator: ".",
      suffix: "",
    },
  ];
}

// Récupérer
async function ServicesDetailDataApp ( periode )
{
  const transactions = await getSoldeTransaction( periode );
  const courses = await getCourses( periode );
  const livraisons = await getLivraisons( periode );
  const evenements = await getEvent();

  let non_publier = 0;
  try
  {
    non_publier =
      Number( evenements.total_passe_non_publier ) +
      Number( evenements.total_avenir_non_publier ) +
      Number( evenements.total_en_cour_non_publier );
  } catch ( error )
  {
    console.error(
      "Erreur  lors de la deduction du nombre d'evenements non publié "
    );
  }

  // console.log( "total non publier: ", non_publier );
  // console.log( "total annule publier: ", Number( evenements.total_passe_publier ) );
  // console.log( "total avenir publier: ", Number( evenements.total_avenir_publier ) );
  // console.log( "total en cour publier: ", Number( evenements.total_en_cour_publier ) );

  return [
    {
      title: `Montant: ${ ( transactions && transactions.total_transactions ) || 0
        }`,
      label: [ "Débité", "Crédité" ],
      data: [
        ( transactions && transactions.total_debits ) || 0,
        ( transactions && transactions.total_credits ) || 0,
      ],
      color: '["--vz-danger", "--vz-success"]',
    },
    {
      // id: 1,
      cardColor: "primary",
      title: "Courses",
      label: [ "Annulée", "Attente", "Terminé", "En cours" ],
      data: [
        courses.Annuler,
        courses.Attente,
        courses.Terminer,
        courses.Encours,
      ],
      color: '["--vz-danger", "--vz-warning", "--vz-success", "--vz-primary"]',
    },
    {
      // id: 1,
      cardColor: "primary",
      title: "Livraisons",
      label: [ "Annulée", "Attente", "Terminé", "En cours" ],
      data: [
        livraisons.Annuler,
        livraisons.Attente,
        livraisons.Terminer,
        livraisons.Encours,
      ],
      color: '["--vz-danger","--vz-warning","--vz-success","--vz-primary" ]',
    },
    {
      // id: 1,
      cardColor: "primary",
      title: "Evénements",
      label: [ "Non Publié", "Passée", "A venir", "En Cours" ],
      data: [
        non_publier,
        Number( evenements.total_passe_publier ),
        Number( evenements.total_avenir_publier ),
        Number( evenements.total_en_cour_publier ),
      ],
      color: '["--vz-info","--vz-danger","--vz-warning","--vz-primary"]',
    },
  ];
}


// Récupérer les revenues de la vente de ticket
async function RevenueDataTicket ( periode )
{
  let labels = [];
  let data = [];

  const now = new Date();
  const revenueMonth = await getRevenueTicketMonth();
  // console.log( 'revenueMonth: ', revenueMonth );

  switch ( periode )
  {
    case "an":
      // Les 5 dernières années
      for ( let i = 0; i < 5; i++ )
      {
        const year = format( subYears( now, i ), "yyyy" );
        labels.unshift( year );
        const totalRevenue = revenueMonth
          ? revenueMonth
            .filter( ( entry ) => entry.mois_annee.startsWith( year ) )
            .reduce( ( sum, entry ) => sum + entry.revenu_mensuel, 0 )
          : 0;
        data.unshift( totalRevenue );
      }
      break;
    case "mois":
      // Les 12 derniers mois
      for ( let i = 0; i < 12; i++ )
      {
        const month = format( subMonths( now, i ), "MMM yyyy" );
        const monthKey = format( subMonths( now, i ), "yyyy-MM" );
        labels.unshift( month );
        const monthlyEntry = revenueMonth
          ? revenueMonth.find( ( entry ) => entry.mois_annee === monthKey )
          : null;
        const monthlyRevenue = monthlyEntry ? monthlyEntry.revenu_mensuel : 0;
        data.unshift( monthlyRevenue );
      }
      break;
    case "semaine":
      // Les 12 dernières semaines
      for ( let i = 0; i < 12; i++ )
      {
        const week = format( subWeeks( now, i ), "wo 'week' yyyy" );
        const weekKey = format( subWeeks( now, i ), "yyyy-ww" );
        labels.unshift( week );
        const weeklyEntry = revenueMonth
          ? revenueMonth.find( ( entry ) => entry.mois_annee === weekKey )
          : null;
        const weeklyRevenue = weeklyEntry ? weeklyEntry.revenu_mensuel : 0;
        data.unshift( weeklyRevenue );
      }
      break;
    default:
      break;
  }

  // console.log( "labels: ", labels );
  // console.log( "data: ", data );

  return { labels, data };
}


// Récupérer les revenues
async function RevenueDataApp ( periode )
{
  let labels = [];
  let data = [];

  const now = new Date();
  const revenueMonth = await getRevenueMonth();
  // console.log( 'revenueMonth: ', revenueMonth );

  switch ( periode )
  {
    case "an":
      // Les 5 dernières années
      for ( let i = 0; i < 5; i++ )
      {
        const year = format( subYears( now, i ), "yyyy" );
        labels.unshift( year );
        const totalRevenue = revenueMonth
          ? revenueMonth
            .filter( ( entry ) => entry.mois_annee.startsWith( year ) )
            .reduce( ( sum, entry ) => sum + entry.revenu_mensuel, 0 )
          : 0;
        data.unshift( totalRevenue );
      }
      break;
    case "mois":
      // Les 12 derniers mois
      for ( let i = 0; i < 12; i++ )
      {
        const month = format( subMonths( now, i ), "MMM yyyy" );
        const monthKey = format( subMonths( now, i ), "yyyy-MM" );
        labels.unshift( month );
        const monthlyEntry = revenueMonth
          ? revenueMonth.find( ( entry ) => entry.mois_annee === monthKey )
          : null;
        const monthlyRevenue = monthlyEntry ? monthlyEntry.revenu_mensuel : 0;
        data.unshift( monthlyRevenue );
      }
      break;
    case "semaine":
      // Les 12 dernières semaines
      for ( let i = 0; i < 12; i++ )
      {
        const week = format( subWeeks( now, i ), "wo 'week' yyyy" );
        const weekKey = format( subWeeks( now, i ), "yyyy-ww" );
        labels.unshift( week );
        const weeklyEntry = revenueMonth
          ? revenueMonth.find( ( entry ) => entry.mois_annee === weekKey )
          : null;
        const weeklyRevenue = weeklyEntry ? weeklyEntry.revenu_mensuel : 0;
        data.unshift( weeklyRevenue );
      }
      break;
    default:
      break;
  }

  // console.log( "labels: ", labels );
  // console.log( "data: ", data );

  return { labels, data };
}

// !============================= Dashboard

// !=== Activity détails
// Récupérer les commentaires sur un chauffeur
async function getCommentChauffeur ( id_agent )
{
  const idAgent = Number( id_agent );
  const coursesList = await getCoursesChauffeurList();
  // console.log("courseComment getCommentChauffeur: ", coursesList);

  const courseComment = coursesList.filter(
    ( course ) =>
      course.conducteur_id === idAgent &&
      course.commentaire !== null &&
      course.commentaire !== ""
  );

  // .map((course) => ({
  //   last_name_client: course.last_name_client,
  //   first_name_client: course.first_name_client,
  //   client_id: course.client_id,
  //   commentaire: course.commentaire,
  //   date: course.updated_at,
  // }));
  // console.log("courseComment getCommentChauffeur: ", courseComment);
  return courseComment;
}

// Récupérer les commentaires sur un chauffeur
async function getNoteChauffeur ( id_agent )
{
  const idAgent = Number( id_agent );
  const coursesList = await getCoursesChauffeurList();
  // console.log("courseComment getCommentChauffeur: ", coursesList);

  const noteCourse = coursesList.filter(
    ( course ) =>
      course.conducteur_id === idAgent &&
      course.note !== null &&
      course.note !== ""
  );
  // .map((course) => ({
  //   last_name_client: course.last_name_client,
  //   first_name_client: course.first_name_client,
  //   client_id: course.client_id,
  //   commentaire: course.commentaire,
  //   date: course.updated_at,
  // }));
  // console.log("noteCourse getCommentChauffeur: ", noteCourse);
  return noteCourse;
}

// Récupérer les revenues sur un chauffeur
async function getRevenuebyChauffeur ( id_agent )
{
  const idAgent = Number( id_agent );
  const coursesList = await getCoursesChauffeurList();

  const totalRevenue = coursesList
    .filter(
      ( course ) =>
        course.conducteur_id === idAgent && course.cout_effective !== null
    )
    .reduce( ( sum, course ) =>
    {
      // Convert course.cout_effective to a number and add to sum if it's valid
      const coutEffective = Number( course.cout_effective );
      return sum + ( isNaN( coutEffective ) ? 0 : coutEffective );
    }, 0 );

  return totalRevenue;
}

// Récupérer les courses par un chauffeur
async function getCoursesChauffeur ( id_agent )
{
  const idAgent = Number( id_agent );

  try
  {
    const coursesList = await getCoursesChauffeurList();
    const coursesDriver = coursesList.filter(
      ( course ) => course.conducteur_id === idAgent
    );
    return coursesDriver.length || 0;
  } catch ( error )
  {
    console.error( "Echec de récupération des données: ", error );
    return 0; // Return 0 or an empty array depending on your requirement
  }
}

// Récupérer les courses où le chauffeur est impliqué (Chauffeur/client)
async function getCoursesChauffeurIn ( id_agent )
{
  const idAgent = Number( id_agent );

  const coursesList = await getCoursesChauffeurList();
  // console.log("CoursesList: ", coursesList);
  // console.log("idAgent: ", idAgent);

  return coursesList
    .filter(
      ( course ) =>
        course.conducteur_id === idAgent || course.client_id === idAgent
    )
    .map( ( course ) =>
    {
      let role = "";
      let last_name = null;
      let first_name = null;
      let id = null;
      let date = null;
      if ( course.conducteur_id === idAgent )
      {
        role = "Conducteur";
        last_name = course.last_name_client || "";
        first_name = course.first_name_client || "";
        id = course.conducteur_id;
        date = course.updated_at;
      } else if ( course.client_id === idAgent )
      {
        role = "Client";
        last_name = course.last_name_conducteur || "";
        first_name = course.first_name_conducteur || "";
        id = course.client_id;
        date = course.updated_at;
      }

      return {
        id: id,
        last_name: last_name,
        first_name: first_name,
        date: date,
        course_status: course.course_status,
        role: role,
      };
    } );
}

// Récupérer les courses où le chauffeur est impliqué (Chauffeur/client)
async function getCoursesClientIn ( id_agent )
{
  const idAgent = Number( id_agent );

  const coursesList = await getCoursesChauffeurList();
  const livraisonList = await getCoursesLivreurList();
  // console.log("CoursesList: ", coursesList);
  // console.log("LivraisonList: ", livraisonList);
  // console.log("idAgent: ", idAgent);

  // Filtrer et mapper coursesList
  const filteredCourses = coursesList
    .filter( ( course ) => course.client_id === idAgent )
    .map( ( course ) => ( {
      id: course.client_id,
      last_name: course.last_name_conducteur || "",
      first_name: course.first_name_conducteur || "",
      date: course.updated_at,
      status: course.course_status,
      type: "Course",
    } ) );
  // Filtrer et mapper livraisonList
  const filteredLivraisons = livraisonList
    .filter( ( course ) => course.client_id === idAgent )
    .map( ( course ) => ( {
      id: course.client_id,
      last_name: course.last_name_conducteur || "",
      first_name: course.first_name_conducteur || "",
      date: course.updated_at,
      status: course.statut,
      type: "Livraison",
    } ) );
  // Combiner les résultats
  return [ ...filteredCourses, ...filteredLivraisons ];
}

// Récupérer les courses où le chauffeur est impliqué (Chauffeur/client)
async function getParainageInfoClient ( id_agent )
{
  const idAgent = Number( id_agent );
  let filleul = 0;
  let gains = 0;
  try
  {
    const response = await axiosInstance.poste( "/filleulesomme/", {
      id: idAgent,
    } );
    // return response.data ? response.data.data : null;
    if ( response?.data )
    {
      let parainageData = response.data.data;

      filleul = parainageData.total_filleuls;
      gains = parainageData.total_gains;
    }
  } catch ( error )
  {
    console.log(
      "Erreur lors de la récupération des informations du parainage: ",
      error
    );
  }

  // Combiner les résultats
  return { filleul: filleul, gains: gains };
}

// Récupérer les commentaires sur un livreur
async function getCommentLivreur ( id_agent )
{
  const idAgent = Number( id_agent );

  const livraisonList = await getCoursesLivreurList();

  return livraisonList
    .filter( ( course ) => course.conducteur_id === idAgent && course.info_sup )
    .map( ( course ) => ( {
      last_name_client: course.last_name_client,
      first_name_client: course.first_name_client,
      client_id: course.client_id,
      commentaire: course.info_sup,
      date: course.updated_at,
    } ) );
}

// Récupérer les revenues sur un livreur
async function getRevenuebyLivreur ( id_agent )
{
  const idAgent = Number( id_agent );

  const livraisonList = await getCoursesLivreurList();
  const totalRevenue = livraisonList
    .filter(
      ( course ) =>
        course.conducteur_id === idAgent && course.cout_effective !== null
    )
    .reduce( ( sum, course ) => sum + course.cout_effective, 0 );

  return totalRevenue;
}

// Récupérer les courses par un livreur
async function getLivreurCourses ( id_agent )
{
  const idAgent = Number( id_agent );

  const coursesList = await getCoursesLivreurList();
  const coursesDriver = coursesList.filter(
    ( course ) => course.conducteur_id === idAgent
  );
  return coursesDriver.length || 0;
}

// Récupérer les courses où le livreur est impliqué (livreur/client)
async function getLivreurCoursesIn ( id_agent )
{
  const idAgent = Number( id_agent );

  const livraisonList = await getCoursesLivreurList();

  return livraisonList
    .filter(
      ( course ) =>
        course.conducteur_id === idAgent || course.client_id === idAgent
    )
    .map( ( course ) =>
    {
      let role = "";
      let last_name = "";
      let first_name = "";
      let id = null;
      let date = null;

      if ( course.conducteur_id === idAgent )
      {
        role = "Livreur";
        last_name = course.last_name_client;
        first_name = course.first_name_client;
        id = course.client_id;
      } else if ( course.client_id === idAgent )
      {
        role = "Client";
        last_name = course.last_name_conducteur;
        first_name = course.first_name_conducteur;
        id = course.conducteur_id;
      }

      return {
        role: role,
        last_name: last_name,
        first_name: first_name,
        statut: course.statut,
        id: id,
        date: course.created_at,
      };
    } );
}
// getCoursesLivreurList();

// Récupérer les courses où le chauffeur est impliqué (Chauffeur/client)
async function getAllActivities ()
{
  const coursesList = await getCoursesChauffeurList();
  const livraisonList = await getCoursesLivreurList();
  // console.log("CoursesList: ", coursesList);
  // console.log("LivraisonList: ", livraisonList);
  // console.log("idAgent: ", idAgent);

  // Filtrer et mapper coursesList
  const filteredCourses = coursesList
    .filter(
      ( course ) =>
        course.cout_effectif !== "" &&
        course.cout_effectif !== 0 &&
        course.cout_effective !== null
    )
    .map( ( course ) => ( {
      client_id: course.client_id,
      conducteur_id: course.conducteur_id,
      last_name_conducteur: course.last_name_conducteur || "",
      first_name_conducteur: course.first_name_conducteur || "",
      last_name_client: course.last_name_client || "",
      first_name_client: course.first_name_client || "",
      mode_payement: course.mode_payement,
      distance_effective: course.distance_effective,
      cout_effectif: course.cout_effectif,
      date: course.date_course,
      status: course.course_status,
      type: "Course",
    } ) );

  // Filtrer et mapper livraisonList
  const filteredLivraisons = livraisonList
    .filter(
      ( livraison ) =>
        livraison.cout_effectif !== "" &&
        livraison.cout_effectif !== 0 &&
        livraison.cout_effective !== null
    )
    .map( ( livraison ) => ( {
      client_id: livraison.client_id,
      conducteur_id: livraison.conducteur_id,
      last_name_conducteur: livraison.last_name_conducteur || "",
      first_name_conducteur: livraison.first_name_conducteur || "",
      last_name_client: livraison.last_name_client || "",
      first_name_client: livraison.first_name_client || "",
      mode_payement: livraison.mode_payement,
      distance_effective: livraison.distance_effective,
      cout_effectif: livraison.cout_effective,
      date: livraison.date_livraison,
      status: livraison.statut,
      type: "Livraison",
    } ) );
  // Combiner les résultats
  return [ ...filteredCourses, ...filteredLivraisons ];
}
// getTicketsGain

// Récupération de la liste des courses des chauffeurs
async function getTakciEarn ()
{
  try
  {
    const res = await axiosInstance.get( "/adminportefeuille/" );
    // return res.data ? res.data.data : null;
    // console.log("response getTakciEarn: ", res);
    if ( res?.data?.portefeuille )
    {
      const portefeuille = res.data.portefeuille;
      // console.log("portefeuille: ", portefeuille);
      let data = portefeuille[ 0 ].solde || 0;
      return data;
    }
  } catch ( error )
  {
    console.log(
      "Erreur lors de la récupération du portefueille de takci: ",
      error
    );
  }
  return 0;
}
// !============================= Activity détails

export
{
  widgetDataApp,
  RevenueDataApp,
  RevenueDataTicket,

  ServicesDetailDataApp,
  getCommentChauffeur,
  getNoteChauffeur,
  getRevenuebyChauffeur,
  getCoursesChauffeur,
  getCoursesChauffeurIn,
  getCommentLivreur,
  getRevenuebyLivreur,
  getLivreurCourses,
  getLivreurCoursesIn,
  getCoursesClientIn,
  getParainageInfoClient,
  getAllActivities,
  getTakciEarn,
};
// Administrateur


// Organisateur

// !---------------------------- Functions Admin

// Récupération des statistiques
async function getStartOrga ()
{
  try
  {
    const res = await axiosInstance.get( "/getstartcountorga/" );

    // console.log( "getstartcountorga: ", res.data.data )
    return res.data && res.data.data
      ? res.data.data
      : {};
  } catch ( error )
  {
    console.error( "Erreur de récupération des statistiques: ", error );
    return {};
  }
}

async function widgetDataOrgaApp ()
{
  const startOrga = await getStartOrga();
  // console.log( "startOrga: ", startOrga );

  return [
    {
      id: 1,
      cardColor: "primary",
      label: "Portefeuille",
      counter: startOrga?.solde_portefeuille || 0,
      link: "Voir portefeuille",
      location: "/organisateurs-ask-pay",
      bgcolor: "success",
      icon: "bx bx-wallet",
      decimals: 0,
      prefix: "",
      separator: ".",
      suffix: "",
    },
    {
      id: 2,
      cardColor: "secondary",
      label: "Événements",
      counter: startOrga?.total_evenement || 0,
      link: "Liste des événements",
      location: "/evenements",
      bgcolor: "info",
      icon: "bx bx-box",
      decimals: 0,
      prefix: "",
      separator: ".",
      suffix: "",
    },
    {
      id: 3,
      cardColor: "info",
      label: "Événements passés",
      counter: startOrga?.total_passe_publier || 0,
      link: "Liste des événements passés",
      location: "/evenements",
      bgcolor: "info",
      icon: "bx bx-box",
      decimals: 0,
      prefix: "",
      separator: ".",
      suffix: "",
    },
    {
      id: 4,
      cardColor: "success",
      label: "Événements futurs publiés",
      counter: startOrga?.total_avenir_publier || 0,
      link: "Liste des événements futurs",
      location: "/evenements",
      bgcolor: "info",
      icon: "bx bx-box",
      decimals: 0,
      prefix: "",
      separator: ".",
      suffix: "",
    },
    {
      id: 5,
      cardColor: "danger",
      label: "Événements futurs non publié",
      counter: startOrga?.total_avenir_non_publier || 0,
      link: "Liste des événements futurs",
      location: "/evenements",
      bgcolor: "info",
      icon: "bx bx-box",
      decimals: 0,
      prefix: "",
      separator: ".",
      suffix: "",
    },
    {
      id: 6,
      cardColor: "info",
      label: "Événements en cours",
      counter: startOrga?.total_en_cours_publier || 0,
      link: "Liste des événements en cours",
      location: "/evenements",
      bgcolor: "info",
      icon: "bx bx-box",
      decimals: 0,
      prefix: "",
      separator: ".",
      suffix: "",
    },
  ];
}


// Récupération de la liste des tickets vendues
async function getTicketSelling ()
{
  try
  {
    const res = await axiosInstance.get( "/getventeticketsdetail/" );
    // return res.data ? res.data.data : null;
    let data = res.data ? res.data.data : null;
    return data;
  } catch ( error )
  {
    console.error( "Erreur lors de la récupération historique de vente de ticket. Erreur: ", error );
    return null;
  }
}

export { widgetDataOrgaApp, getTicketSelling }